import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface Cube5Props {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const Cube5: React.FC<Cube5Props> = ({ strokeWidth = 1, ...props }) => (
  <SvgIcon {...props} className="sx-icon-cube5">
    <path
      d="M12 2L3.8 6.7M12 2l8.2 4.7M3.8 6.7L12 12M20.2 6.7L12 12M3.8 6.7v10.6M20.2 6.7v10.6M12 12v10M3.8 17.3L12 22M20.2 17.3L12 22"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export default Cube5;
